<circ-loader [isLoading]="loading">
    <legend >{{ 'step_new_legend' | i18n }}</legend>
    <kendo-dropdownlist [data]="providers" textField="name" valueField="id" [(ngModel)]="selectedProvider"></kendo-dropdownlist>
    <legend ><hr></legend>
    <div *ngIf="providerComponent">
      <ng-container *ngComponentOutlet="providerComponent"></ng-container>
    </div>
</circ-loader>
